
export const API_BASE_URL = 'https://oneandall.se';

// Login

export const LOGIN = '/wp-json/jwt-auth/v1/token'
export const VALIDATE_TOKEN = '/wp-json/jwt-auth/v1/token/validate'

export const USER = '/wp-json/one-and-all/v1/user'

export const FINISH_ASSESSMENT = '/wp-json/one-and-all/v1/assessment/finish'